import { FunctionComponent } from 'react';
import { ServerSideModuleData } from 'src/experiences/MortgageDashboard/GetServerSideProps/utils/getServerSideModuleData';
import { GhostCard } from 'src/experiences/MortgageDashboard/common/components/GhostCard';
import { AssignedTeamMembers } from './AssignedTeamMembers';
import { useAssignedTeamMembersState } from './useAssignedTeamMembersState';

type WiredTeamInformationCardProps = {
    serverFetchedData: Pick<ServerSideModuleData, 'TeamInformationCard'>;
};

export const WiredTeamInformationCard: FunctionComponent<WiredTeamInformationCardProps> = ({ serverFetchedData }) => {
    const props = useAssignedTeamMembersState({
        data: serverFetchedData.TeamInformationCard,
    });

    return (
        <GhostCard>
            <AssignedTeamMembers {...props} />
        </GhostCard>
    );
};
